import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

//service imports
import { HiringService } from '../../hiring/services/hiring.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';

//Pipe imports
import { OrderByPipe } from '../../../shared/pipe/order-by.pipe';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  @ViewChild('welcomeForm', { static: false }) welcomeForm: NgForm;
  formData: { [key: string]: any } = {};
  userNoPIN: boolean = false;
  welcomeText: any;
  enablePINRequest: boolean = false;
  allowUserProfileSelection: boolean = false;
  labelForProfileDropdown: any;
  labelForOnboardingPIN: any;
  removeEmailFromOnboardEnroll: boolean = false;
  portalSettings: any;
  locationList: any[] = [];
  alert: any;
  profilePreBound: boolean = false;
  orderByPipe: any;
  profiles: any[] = [];

  constructor(portalSettingsService: PortalSettingsService, private hiringService: HiringService, private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.welcomeText = this.portalSettings.ONWelcomeText.ConfigValue;
    this.enablePINRequest = this.portalSettings.EnableOnboardingPINRequest.ConfigValue == "1";
    this.userNoPIN = this.portalSettings.ONDefaultNoPinWelcomeScreen.ConfigValue == "1";
    this.allowUserProfileSelection = this.portalSettings.ONAllowUserProfileSelection.ConfigValue == "1";
    this.labelForProfileDropdown = this.portalSettings.ONLabelForProfileDropdown.ConfigValue || "Onboarding Profile";
    this.labelForOnboardingPIN = this.portalSettings.ONLabelForOnboardingPIN.ConfigValue || "Onboarding PIN";
    this.removeEmailFromOnboardEnroll = this.portalSettings.RemoveEmailFromOnboardEnroll.ConfigValue == "1";
    if (this.allowUserProfileSelection) {
      this.getRouteData();
    }
  }

  noPIN() {
    this.userNoPIN = true;
  }

  yesPIN() {
    this.userNoPIN = false;
  }

  locationGet(optional : any) {
    this.hiringService.locationGet().then((response: any) => {
      if (response != null) {
        var sessionTemp = sessionStorage.getItem("OnboardLocationID");
        this.locationList = response;
        this.locationList = this.orderByPipe.transform(this.locationList, "OnboardLocationName", "asc");
        if (this.locationList.length > 0) {
          if (this.locationList.length == 1 || sessionTemp == null) {
            this.formData.OnboardLocationID = this.locationList[0].OnboardLocationID;
          }
          else if (sessionTemp != null) {
            var count = 0;
            this.locationList.forEach(val => {
              if (sessionTemp == val.OnboardLocationID)
                count++;
            });
            if (count == 0)
              this.formData.OnboardLocationID = this.locationList[0].OnboardLocationID;
            else
              this.formData.OnboardLocationID = parseInt(sessionTemp);
          }
          this.updateProfile(optional);
        }
      }
    });
  }

  updateProfile(optional: any) {
    if (this.formData.OnboardLocationID != null)
      sessionStorage.setItem("OnboardLocationID", this.formData.OnboardLocationID);
    if (optional == null)
      this.getProfiles(null);
    else
      this.getProfiles(optional);
  }

  continue() {
    if (this.userNoPIN) {
      this.hiringService.logout().then((logoutResponse: any) => {
        let requestObj: { [key: string]: any } = {};
        requestObj.firstName = this.formData.firstName;
        requestObj.lastName = this.formData.lastName;
        requestObj.email = this.formData.email;
        requestObj.onboardProfileID = this.allowUserProfileSelection ? this.formData.profile.OnboardProfileID : null;
        
        this.hiringService.beginOnboardingProcess(requestObj).then((response: any) => {
          if (response.success) {
            window.location.href = "/careers/tasks"; // this needs to be a page refresh, don't use angular routing here
          }
          else {
            this.alert = { type: "danger", msg: response.errorMessage }
          }
        });
      });
    }
    else {
      this.hiringService.logout().then((logoutResponse: any) => {
        let requestObj: { [key: string]: any } = {};
        requestObj.firstName = this.formData.firstName;
        requestObj.lastName = this.formData.lastName;
        requestObj.onboardingPIN = this.formData.onboardingPIN;
        this.hiringService.beginOnboardingProcess(requestObj).then((response: any) => {
          if (response.success) {
            window.location.href = "/careers/tasks"; // this needs to be a page refresh, don't use angular routing here
          }
          else {
            this.alert = { type: "danger", msg: response.errorMessage }
          }
        });
      });
    }
  }

  getProfiles(profileToBind: any) {
    this.formData.profile = null;
    this.hiringService.getProfiles('O',this.formData.PRCo, this.formData.OnboardLocationID).then((response: any) => {
      this.profiles = response;
      if (this.profiles.length > 0) {
        if (profileToBind != null) {
          for (var i = 0; i < this.profiles.length; i++) {
            if (this.profiles[i].OnboardProfileID == profileToBind) {
              this.formData.profile = this.profiles[i];
              this.profilePreBound = true;
              break;
            }
          }
        }
      }
    });
  }

  getRouteData() {
    var path = window.location.hash;
    var routeRegex = /^#(?:[/]Profile[/](\d+))?(?:[/]C[/](\d+))?$/i;
    var routeMatch = routeRegex.exec(path);
    if (routeMatch != null) {
      this.formData.PRCo = routeMatch[2];
      this.locationGet(routeMatch[1]);
    } else {
      this.locationGet(null);
    }
  }

  closeAlert() {
    this.alert = null;
  }

}